import { WebPlugin } from '@capacitor/core';
export class AppUpdateWeb extends WebPlugin {
    async getAppUpdateInfo() {
        throw new Error('Web platform is not supported.');
    }
    async openAppStore() {
        throw new Error('Web platform is not supported.');
    }
    async performImmediateUpdate() {
        throw new Error('Web platform is not supported.');
    }
    async startFlexibleUpdate() {
        throw new Error('Web platform is not supported.');
    }
    async completeFlexibleUpdate() {
        throw new Error('Web platform is not supported.');
    }
}
//# sourceMappingURL=web.js.map